module.exports = __webpack_public_path__ + "static/media/submit-bid-head-icon.67bc7b4e.svg";